import { FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekFormControlLabel = styled(FormControlLabel)(({ theme }) => ({}));

export { PeekFormControlLabel, PeekFormControlLabel as default };
